export const IATA_CODES = [
  "AGR", "AGX", "AHA", "AIP", "AJL",
  "AMD", "ATQ", "AYJ", "BBI", "BDQ",
  "BEK", "BHO", "BHJ", "BHU", "BKR",
  "BKB", "BLR", "BOM", "BUP", "CCJ",
  "CCU", "CDP", "CJB", "COK", "CNN",
  "DED", "DEL", "DHM", "DIB", "DIU",
  "DMU", "DXN", "GAU", "GAY", "GOI", "GOX",
  "GWL", "HGI", "HJR", "HSS", "HSR",
  "HYD", "IDR", "IMF", "ISK", "IXA",
  "IXB", "IXC", "IXE", "IXG", "IXI",
  "IXJ", "IXM", "IXP", "IXR", "IXS",
  "IXT", "IXU", "IXW", "IXZ", "JAI",
  "JDH", "JGB", "JLR", "JRH", "JSA",
  "KJB", "KLH", "KNU", "KQH", "KTU",
  "KUU", "LKO", "LUH", "MAA", "MYQ",
  "NAG", "NDC", "PAB", "PAT", "PBD",
  "PNQ", "PNY", "PYG", "RAJ", "RJA",
  "RPR", "RUP", "SAG", "SHL", "SLV",
  "STV", "SXR", "SXV", "TEI", "TIR",
  "TCR", "TRV", "TRZ", "UDR", "VGA",
  "VNS", "VTZ", "ZER"
].sort();
